import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";

import { AppComponent } from "./app.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgxSpinnerModule } from "ngx-spinner";
import { AlertModule } from "ngx-alerts";
import { Routes, RouterModule } from "@angular/router";
import { HttpClientModule } from "@angular/common/http";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import {
  MatDatepickerModule,
  MatInputModule,
  MatNativeDateModule,
  MatDialogModule,
} from "@angular/material";
import { Angular4PaystackModule } from "angular4-paystack";
import { DlaService } from "./shared/dla.service";
import { AuthGuard } from "./auth/auth.guard";
import { FooterComponent } from "./components/shared/footer/footer.component";
import { HeaderComponent } from "./components/shared/header/header.component";
import { LoginComponent } from "./components/auth/login/login.component";
import { RegisterComponent } from "./components/auth/register/register.component";
import { ConfirmEmailComponent } from "./components/auth/confirm-email/confirm-email.component";
import { ForgotPasswordComponent } from "./components/auth/forgot-password/forgot-password.component";
import { ResetPasswordComponent } from "./components/reset-password/reset-password.component";
import { HomeComponent } from "./components/home/home.component";
import { MobileNavComponent } from "./components/shared/mobile-nav/mobile-nav.component";
import { HeaderTopComponent } from "./components/shared/header-top/header-top.component";
import { MobileLogoComponent } from "./components/shared/mobile-logo/mobile-logo.component";
import { BreadcrumAreaComponent } from "./components/shared/breadcrum-area/breadcrum-area.component";
import { MainHeaderComponent } from "./components/shared/main-header/main-header.component";
import { MyProfileComponent } from "./components/my-profile/my-profile.component";
import { StudentSessionComponent } from "./components/student-session/student-session.component";
import { DonateComponent } from "./components/donate/donate.component";
import { NotFoundComponent } from "./components/not-found/not-found.component";
import { OfflinePaymentComponent } from "./components/offline-payment/offline-payment.component";
import { Register2Component } from "./components/auth/register2/register2.component";
import { FeedbackComponent } from "./components/feedback/feedback.component";
import { MessageComponent } from "./components/message/message.component";
import { ForumComponent } from "./components/forum/forum.component";
import { SentMessagesComponent } from "./components/sent-messages/sent-messages.component";
import { SendMailComponent } from "./components/send-mail/send-mail.component";
import { ReplyMailComponent } from "./components/reply-mail/reply-mail.component";
// import { EditorModule, TINYMCE_SCRIPT_SRC } from '@tinymce/tinymce-angular';
import { SendMailFacilitatorComponent } from "./components/send-mail-facilitator/send-mail-facilitator.component";
import { ForumDetailsComponent } from "./components/forum-details/forum-details.component";
import { ViewMessageComponent } from "./components/view-message/view-message.component";
import { SessionHistoryComponent } from "./components/session-history/session-history.component";
import { TransactionHistoryComponent } from "./components/transaction-history/transaction-history.component";
import { OnlinePaymentConfirmationComponent } from "./components/online-payment-confirmation/online-payment-confirmation.component";
import { CouponComponent } from "./components/coupon/coupon.component";
import { CouponPaymentComponent } from "./components/coupon-payment/coupon-payment.component";
import { ConfirmRegistrationComponent } from "./components/auth/confirm-registration/confirm-registration.component";
import { CurrencyPipe } from "@angular/common";
import { ConfirmCouponComponent } from './components/confirm-coupon/confirm-coupon.component';

const routes: Routes = [
  { path: "", component: HomeComponent, canActivate: [AuthGuard] },
  { path: "login", component: LoginComponent },
  { path: "register", component: RegisterComponent },
  { path: "registerNext", component: Register2Component },
  { path: "forgot-password", component: ForgotPasswordComponent },
  { path: "confirm-email", component: ConfirmEmailComponent },
  { path: "confirm-registration", component: ConfirmRegistrationComponent },
  { path: "coupon", component: CouponComponent },
  { path: "confirm-coupon", component: ConfirmCouponComponent },
  {
    path: "change-password",
    component: ResetPasswordComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "my-profile",
    component: MyProfileComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "student-session/:id",
    component: StudentSessionComponent,
    canActivate: [AuthGuard],
  },
  { path: "donate", component: DonateComponent, canActivate: [AuthGuard] },
  { path: "feedback", component: FeedbackComponent, canActivate: [AuthGuard] },
  { path: "message", component: MessageComponent, canActivate: [AuthGuard] },
  { path: "sent", component: SentMessagesComponent, canActivate: [AuthGuard] },
  {
    path: "compose-mail",
    component: SendMailComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "compose-mail-facilitator",
    component: SendMailFacilitatorComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "reply-message/:id/:type",
    component: ReplyMailComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "view-message/:id/:type",
    component: ViewMessageComponent,
    canActivate: [AuthGuard],
  },
  { path: "forum", component: ForumComponent, canActivate: [AuthGuard] },
  {
    path: "forum-details/:id",
    component: ForumDetailsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "session-hstory",
    component: SessionHistoryComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "transaction-hstory",
    component: TransactionHistoryComponent,
    canActivate: [AuthGuard],
  },
  { path: "", redirectTo: "/", pathMatch: "full" },
  { path: "404", component: NotFoundComponent },
  { path: "**", redirectTo: "404" },
];

@NgModule({
  declarations: [
    AppComponent,
    FooterComponent,
    HeaderComponent,
    LoginComponent,
    RegisterComponent,
    ConfirmEmailComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    HomeComponent,
    MobileNavComponent,
    HeaderTopComponent,
    MobileLogoComponent,
    BreadcrumAreaComponent,
    MainHeaderComponent,
    MyProfileComponent,
    StudentSessionComponent,
    DonateComponent,
    NotFoundComponent,
    OfflinePaymentComponent,
    Register2Component,
    FeedbackComponent,
    MessageComponent,
    ForumComponent,
    SentMessagesComponent,
    SendMailComponent,
    ReplyMailComponent,
    SendMailFacilitatorComponent,
    ForumDetailsComponent,
    ViewMessageComponent,
    SessionHistoryComponent,
    TransactionHistoryComponent,
    OnlinePaymentConfirmationComponent,
    CouponComponent,
    CouponPaymentComponent,
    ConfirmRegistrationComponent,
    ConfirmCouponComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(routes),
    NgxSpinnerModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatInputModule,
    MatDialogModule,
    FormsModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatInputModule,
    AlertModule.forRoot({
      maxMessages: 5,
      timeout: 5000,
      position: "right",
    }),
    Angular4PaystackModule.forRoot(
      "pk_live_841a2ad5b9b0ac15691599a84cd4e532658e62c4"
    ),
    //EditorModule,
    // Angular4PaystackModule.forRoot(
    //   "pk_test_21a006ba15e2de1bb6d7bf0f18fbe09283060ac6"
    // ),
  ],
  entryComponents: [
    OfflinePaymentComponent,
    OnlinePaymentConfirmationComponent,
    CouponPaymentComponent,
  ],
  providers: [DlaService, AuthGuard, CurrencyPipe],
  bootstrap: [AppComponent],
})
export class AppModule {}
